
import React from "react";
import ReactDOM from "react-dom";

import { Route, Switch, Redirect, BrowserRouter } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";
import "react-toastify/dist/ReactToastify.css";

// layouts
import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";


// views without layouts
import Landing from "views/Landing.js";
import Profile from "views/Profile.js";

import ItemView from "views/user/ItemView.js";

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      {/* add routes with layouts */}
      <Route path="/admin" component={Admin} />
      <Route path="/auth" component={Auth} />
      {/* add routes without layouts */}
      <Route path="/landing" exact component={Landing} />
      <Route path="/profile" exact component={Profile} />

      {/*route to item view*/}
      <Route path="/item/:id" component={ItemView}/> 

      <Route path="/"> 
        <Redirect from="*" to="/auth/login" />
      </Route>
      {/* <Redirect to="/auth/login" /> */}
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
